<template>
  <el-table
    :data="tableData"
    ref="managetypeTable"
    highlight-current-row
    height="100%"
    :class="['popup', 'managetype-table', disabled ? 'disabled' : '']"
    style="width: 100%"
    @row-click="tableRowClick"
  >
    <el-table-column v-if="isMultiple" prop="check_flag" header-align="left" align="left" label="선택" width="50">
      <template slot-scope="scope">
        <el-checkbox v-model="scope.row['check_flag']"></el-checkbox>
      </template>
    </el-table-column>
    <el-table-column
    prop="managetypeName"
    label="관리구분명"
    header-align="left"
    align="left"
    >
  </el-table-column>
  </el-table>
</template>

<script>
import ManagetypeAPI from '@/api/model/managetype';
import { isEmpty } from '@/utils/basic';
import find from 'lodash/find';
import remove from 'lodash/remove';
import union from 'lodash/union';

export default {
  name: 'WManagetypeTable',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    managetypeInfo: {
      type: Array,
      default() {},
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumns: [
        { prop: 'managetypeName', label: '관리구분명', headerAlign: 'center' },
      ],
      tableData: null,
      curruntRow: null,
      exManagetypeIds: ['SVC', 'LMS', 'COMMON'],
    };
  },
  mounted() {
    ManagetypeAPI.getActiveManagetypeList().then((response) => {
      const data = response.data.data;
      // 활성화된 관리구분 리스트에서 위젯에서 표현하지않는 관리구분을 제외한다.
      this.exManagetypeIds.forEach((managetypeId) => {
        remove(data, (v) => v.managetypeId === managetypeId);
      });
      this.tableData = data;
      this.$nextTick(() => {
        this.setManagetypeInfo();
      });
    });
  },
  methods: {
    setExManagetypeIds(ids) {
      // 제외될(위젯에서 표현하지않는) 관리구분을 설정한다.
      this.exManagetypeIds = union(this.exManagetypeIds, ids);
    },
    setManagetypeInfo() {
      if (!isEmpty(this.managetypeInfo[0])) {
        if (!this.isMultiple) {
          this.setManagetypeTableCurrentRow();
        } else {
          this.tableData.forEach((item) => {
            this.setCheckedManagetype(item, this.managetypeInfo);
          });
        }
      }
    },
    setManagetypeTableCurrentRow() {
      const managetypeInfo = find(this.tableData, { managetypeId: this.managetypeInfo[0] });
      managetypeInfo.check_flag = true;
      this.$refs.managetypeTable.setCurrentRow(managetypeInfo);
      this.curruntRow = managetypeInfo;
    },
    setCheckedManagetype(item, managetypeInfo) {
      managetypeInfo.forEach((managetype) => {
        if (managetype === item.managetypeId) {
          item.check_flag = true;
        }
      });
    },
    tableRowClick(row) {
      this.curruntRow = row;
    },
    getCurreuntRow() {
      return this.curruntRow;
    },
    getCurruntData() {
      const currentData = [];
      if (!isEmpty(this.tableData)) {
        this.tableData.forEach((item) => {
          if (item.check_flag) {
            currentData.push(item);
          }
        });
      }
      return currentData;
    },
    getTableData() {
      return this.tableData;
    },
  },
};
</script>

<style>
.managetype-table {
  transition: opacity .15s ease-in .05s;
  -webkit-transition: opacity .15s ease-in .05s;
}
.managetype-table.disabled {
  opacity: 0.4;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/grid/setting/components/ManagetypeTable.vue